import { Box, BoxProps } from '@mui/material';
import DomPurify from 'dompurify';
import { spreadSx } from 'ui-kit/lib/utils/spreadSx';
import cn from 'classnames';
interface HtmlProps extends BoxProps {
  children?: string;
}
export const RenderHtml = ({
  children,
  component,
  sx,
  className,
  ...props
}: HtmlProps) => {
  return (
    <Box
      className={cn('id-render-html-container', className)}
      component={component ?? 'div'}
      dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(children ?? '') }}
      sx={[
        { '*': { whiteSpace: 'pre-wrap', wordBreak: 'break-word' } },
        ...spreadSx(sx),
      ]}
      {...props}
    />
  );
};
